import React from "react";
import { DragOverlay, useDroppable } from "@dnd-kit/core";
import {
  rectSortingStrategy,
  SortableContext,
  verticalListSortingStrategy,
  horizontalListSortingStrategy,
} from "@dnd-kit/sortable";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

import { SortableItem } from "./SortableItem";
import { useTranslation } from "react-i18next";
export const ContainerInput = React.memo(function ContainerInput(props) {
  const {
    id,
    items,
    type,
    handleRemovePlayer,
    openEditSlide,
    feedType,
    countries,
  } = props;

  const { t } = useTranslation();

  const { setNodeRef } = useDroppable({
    id,
  });
  const typeId = "uuid";

  return (
    <SortableContext
      id={id}
      items={items?.map((item) => item[typeId])}
      strategy={horizontalListSortingStrategy}
    >
      <div ref={setNodeRef} className={"sortable-container"}>
        {items?.map((item, index) => {
          return (
            <div className={`player-view-container`}>
              <div className={"player-actions"}>
                <DeleteOutlined
                  style={{ color: "red" }}
                  onClick={(e) => {
                    if (handleRemovePlayer) {
                      handleRemovePlayer(item);
                    }
                  }}
                />
                <EditOutlined
                  onClick={(e) => {
                    openEditSlide(e, item);
                    // openEdit(e, item);
                  }}
                />
              </div>
              <SortableItem
                item={item}
                key={`${index}${item[typeId]}`}
                id={item[typeId]}
                index={index}
                handleRemovePlayer={handleRemovePlayer}
                feedType={feedType}
                countries={countries}
              />
            </div>
          );
        })}
      </div>
    </SortableContext>
  );
});
